import { renderRoutes } from "utils/route";

interface IProps {
  route: any;
}

const BlankLayout = (props: IProps) => {
  const { route } = props;
  return renderRoutes(route.routes);
};

export default BlankLayout;
